import * as types from './types';
import { InvoiceReminderService } from '../../services/invoice-reminder.service';
import { HttpClient } from '../../../../services/http/http-client';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';

export const invoiceReminderActions = {
  async [types.InvoiceReminders.FETCH.ALL] ({commit}) {
    const invoiceReminderList = await InvoiceReminderService.findInvoiceReminders();

    commit(types.InvoiceReminders.SET.ALL, invoiceReminderList.data.invoice_reminder);
  },

  async [types.InvoiceReminders.INSERT.SINGLE]({commit,getters},payload){

     const invoiceReminderList =await InvoiceReminderService.addNewInvoiceReminder({...payload});

     console.log("::::",invoiceReminderList);

     commit(types.InvoiceReminders.SET.ALL,invoiceReminderList.data.invoice_reminder)

  },




  async [types.InvoiceReminders.UPDATE.SINGLE] ({commit, getters}, payload) {
    const { name, value, item } = payload;

    const key = 'invoice_reminder_id';
    const kVal = item[key];
    const table = 'invoice_reminder';

    commit(types.InvoiceReminders.SET.ALL, getters.invoiceReminderList.map(ir => {
      if (ir[key] == kVal) {
        return {
          ...ir,
          [name]: value
        };
      } else {
        return ir;
      }
    }));

    const updatedInvoiceReminder = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );

  },
  async [types.SelectedInvoiceReminder.SET.SINGLE] ({commit}, payload) {
    console.log(payload);

    const { flag, invoice_reminder } = payload;

    commit(SET_MAIN_NAV_ACTIVE, !flag, { root: true });

    if (flag) {
      
      const invoiceReminderDetails = await InvoiceReminderService.findInvoiceReminderDetails({
        invoice_reminder_id: invoice_reminder.invoice_reminder_id
      });

      console.log(":::::",invoiceReminderDetails.data);

      commit(types.SelectedInvoiceReminder.SET.SINGLE, invoiceReminderDetails.data);
    }
  },

   // Deleted Invoice Reminders List
   async [types.InvoiceReminders.DELETE.SINGLE]({ commit, getters }, item) {
    const { invoice_reminder_id } = item;

    let newInvoiceReminderList = getters.invoiceReminderList.filter(
      e => e.invoice_reminder_id != invoice_reminder_id
    );
    
    commit(types.InvoiceReminders.SET.ALL, newInvoiceReminderList);

    const removeInvoiceReminder = await InvoiceReminderService.removeInvoiceReminder(
      invoice_reminder_id
    );
  },

  async [types.SelectedInvoiceReminder.DELETE.SINGLE]({ commit, getters }, item) {
    // console.log("onDeleted Contact Actions ", item);
    const { invoice_reminder_contact_id } = item;

    let newInvoiceContactList = getters.selectedInvoiceReminder.invoice_reminder_contacts.filter(
      e => e.invoice_reminder_contact_id != invoice_reminder_contact_id
    );
    
    commit(types.SelectedInvoiceReminder.SET.SINGLE, {
      ...getters.selectedInvoiceReminder.invoice_reminder_contacts,
      invoice_reminder_contacts: newInvoiceContactList
    });

    const removeInvoiceContact = await InvoiceReminderService.removeInvoiceContact(
      invoice_reminder_contact_id
    );
  },  
};